import { X } from 'lucide-react';

interface AlertDialogCloseButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

/** X de fechar dos AlertDialogs (que não têm um próprio), no estilo do Dialog. */
export function AlertDialogCloseButton({ onClick, disabled }: Readonly<AlertDialogCloseButtonProps>) {
  return (
    <button
      type="button"
      aria-label="Fechar"
      onClick={onClick}
      disabled={disabled}
      className="absolute right-2 top-2 sm:right-4 sm:top-4 z-10 rounded-full p-1 bg-muted/80 hover:bg-muted ring-offset-background transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none"
    >
      <X className="h-4 w-4" />
    </button>
  );
}
